import { auth } from "@/lib/firebase";
import type { ApplicationVerifier } from "firebase/auth";
import {
  PhoneAuthProvider,
  linkWithCredential,
  signInWithPhoneNumber,
} from "firebase/auth";
import { Platform } from "react-native";

// ✅ Web-only compat (gives RecaptchaVerifier class without TS export drama)
import firebase from "firebase/compat/app";
import "firebase/compat/auth";

type LinkFlow = {
  mode: "web" | "native";
  confirm: (code: string) => Promise<boolean>;
};

export function getWebRecaptcha(containerId = "recaptcha-container") {
  if (Platform.OS !== "web") return null;

  const w = window as any;
  if (w.recaptchaVerifier) return w.recaptchaVerifier as ApplicationVerifier;

  // ✅ This exists in compat and is stable in Firebase 12
  const verifier = new (firebase.auth as any).RecaptchaVerifier(containerId, {
    size: "invisible",
  });

  w.recaptchaVerifier = verifier;
  return verifier as ApplicationVerifier;
}

export async function linkPhoneNumber(params: {
  phone: string;
  webVerifier?: ApplicationVerifier | null;
}): Promise<LinkFlow> {
  const phone = params.phone.trim();
  const user = auth.currentUser;
  if (!user) throw new Error("Not logged in");

  if (Platform.OS === "web") {
    const verifier = params.webVerifier;
    if (!verifier) throw new Error("Missing web reCAPTCHA verifier");

    const confirmation = await signInWithPhoneNumber(auth, phone, verifier);

    return {
      mode: "web",
      confirm: async (code: string) => {
        const credential = PhoneAuthProvider.credential(
          confirmation.verificationId,
          code.trim()
        );
        await linkWithCredential(user, credential);
        return true;
      },
    };
  }

  throw new Error(
    "Phone OTP on native requires Dev Client (@react-native-firebase/auth). Expo Go cannot run native phone auth."
  );
}
